import { render, staticRenderFns } from "./MarketReportsMenu.vue?vue&type=template&id=237ddda8&scoped=true&"
import script from "./MarketReportsMenu.vue?vue&type=script&lang=js&"
export * from "./MarketReportsMenu.vue?vue&type=script&lang=js&"
import style0 from "./MarketReportsMenu.vue?vue&type=style&index=0&id=237ddda8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ddda8",
  null
  
)

export default component.exports